import { JobStatus } from 'enum/jobStatus.enum'
import { Resolutions } from 'enum/resolutions.enum'
import { useIsDesktop } from 'helpers'
import { useMemo } from 'react'

import {
  BlockMultimediaContent,
  MultimediaResolution,
} from 'store/states/lessons.state'

interface useURLProps {
  baseUrl: string
  data: BlockMultimediaContent
}

const RESOLUTIONS_RULES = {
  [Resolutions['1080p']]: [Resolutions['1080p'], Resolutions['720p']],
  [Resolutions['720p']]: [Resolutions['720p'], Resolutions['1080p']],
}

export const useURL = ({ baseUrl, data }: useURLProps) => {
  const isDesktop = useIsDesktop()

  const rules = useMemo(
    () =>
      isDesktop
        ? RESOLUTIONS_RULES[Resolutions['1080p']]
        : RESOLUTIONS_RULES[Resolutions['720p']],
    [isDesktop]
  )

  const url = useMemo(() => {
    const { resolutions } = data
    const resolutionsGroup = (resolutions || []).reduce<
      Partial<Record<Resolutions, MultimediaResolution>>
    >((acc, resolution) => {
      acc[resolution.resolution] = resolution
      return acc
    }, {})

    if (resolutions)
      for (const rule of rules) {
        const resolution = resolutionsGroup[rule]
        if (resolution?.state === JobStatus.complete)
          return {
            url: resolution.url,
            type: resolution.fileData?.metadata.mimeType,
            resolution: resolution.resolution,
          }
      }

    return { url: baseUrl, type: data.fileData?.metadata.mimeType }
  }, [baseUrl, data, rules])

  return url
}
